import {
  GET_SEARCH_RESULT_DATA, GET_SEARCH_QUICK_RESULT_DATA, RESET_SEARCH_RESULT_DATA, RESET_SEARCH_QUICK_RESULT_DATA,
} from '../../constants/system/actions';

const getSearchResultData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_SEARCH_RESULT_DATA, payload, resolve, reject,
});

const getSearchQuickResultData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_SEARCH_QUICK_RESULT_DATA, payload, resolve, reject,
});

const resetSearchResultData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_SEARCH_RESULT_DATA, payload,
});

const resetSearchQuickResultData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_SEARCH_QUICK_RESULT_DATA, payload,
});

export {
  getSearchResultData,
  getSearchQuickResultData,
  resetSearchResultData,
  resetSearchQuickResultData,
};
